import Loading from 'core/modules/atoms/Loading';
import React from 'react';
import { useTranslation } from 'react-i18next';

import AnalyticsFilterBar from '../../components/compositions/AnalyticsFilterBar/AnalyticsFilterBar';
import TeacherLayoutWrapper from '../../components/layouts/TeacherLayoutWrapper/TeacherLayoutWrapper';
import { useAnalyticsFilters } from '../../contexts/AnalyticsFiltersContext';
import './_teacher-ai-analytics-panel.scss';
import InappropriateUseSection from './sections/InappropriateUseSection/InappropriateUseSection';
import IntentDistributionSection from './sections/IntentDistributionSection/IntentDistributionSection';
import TopicRankingSection from './sections/TopicRankingSection/TopicRankingSection';

/**
 * TeacherAIAnalyticsPanelView - Main view for the AI analytics panel.
 * Displays class and time period filters with an empty content area for future phases.
 */
function TeacherAIAnalyticsPanelView(): JSX.Element {
  const { t } = useTranslation(['chatbot']);
  const { allCourseIds, groupCourseMap, loading, selectedClass, selectedTimePeriod } = useAnalyticsFilters();

  if (loading) {
    return <Loading />;
  }

  return (
    <TeacherLayoutWrapper activeNavigationId="analytics" sidebarMode="collapsed" showBackArrowWhenCollapsed={true} contentPadding="default">
      <div className="teacher-ai-analytics-panel">
        <div className="teacher-ai-analytics-panel__header">
          <div className="teacher-ai-analytics-panel__header-titles">
            <h1 className="teacher-ai-analytics-panel__title">{t('chatbot:ai_analytics_panel_title')}</h1>
            <p className="teacher-ai-analytics-panel__subtitle">{t('chatbot:ai_analytics_panel_subtitle')}</p>
          </div>
          <div className="teacher-ai-analytics-panel__header-filters">
            <AnalyticsFilterBar />
          </div>
        </div>
        <div className="teacher-ai-analytics-panel__content">
          <InappropriateUseSection
            allCourseIds={allCourseIds}
            classValue={selectedClass.value}
            groupCourseMap={groupCourseMap}
            timePeriodValue={selectedTimePeriod.value}
          />
          <TopicRankingSection
            allCourseIds={allCourseIds}
            classValue={selectedClass.value}
            groupCourseMap={groupCourseMap}
            timePeriodValue={selectedTimePeriod.value}
          />
          <IntentDistributionSection
            allCourseIds={allCourseIds}
            classValue={selectedClass.value}
            groupCourseMap={groupCourseMap}
            timePeriodValue={selectedTimePeriod.value}
          />
        </div>
      </div>
    </TeacherLayoutWrapper>
  );
}

export default TeacherAIAnalyticsPanelView;
